// import Backbone from 'backbone';
import tmpl from '../../templates';
import Promotion from '../../models/promotion';
import namespace from '../../../upi/namespace';

var app = namespace( 'apps.productpage' );

var PromotionModuleView = Backbone.View.extend( {

    className: 'promotion',

    template: _.template( tmpl.promotionModule ),

    events: {
        'click *[data-promo-details]': 'openDetails',
        'click *[data-close]': 'closeDetails'
    },

    initialize: function () {
        // set default model to noop
        this.model = this.model || new Promotion;

        this.listenTo( this.model, 'change:id', this.render );
        this.listenTo( app.mediator, 'close:dialogs', this.closeDetails );
        this.render();
    },

    initEvents: function () {
        this.undelegateEvents();
        this.delegateEvents();
    },

    render: function () {
        this.$el.html( this.template( this.model.attributes ) );
        this.initEvents();

        return this;
    },

    openDetails: function ( e ) {
        app.mediator.trigger( 'close:dialogs' );

        e.preventDefault();
        this.$el.find( '.promoDetailsWrapper' ).toggleClass( 'on' );
    },

    closeDetails: function () {
        this.$el.find( '.promoDetailsWrapper' ).removeClass( 'on' );
    }

} );

export default PromotionModuleView;
